export default function HeroSection() {
  return (
    <section
      className="relative flex items-center overflow-hidden"
      style={{
        background:
          'linear-gradient(135deg, #050505 0%, #1a0a08 35%, #120805 70%, #050505 100%)',
      }}
    >
      {/* Particle-like background dots */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {Array.from({ length: 60 }).map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-[#B80E28]/30"
            style={{
              width: `${Math.random() * 4 + 1}px`,
              height: `${Math.random() * 4 + 1}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `float ${Math.random() * 6 + 4}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 4}s`,
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          {/* Left Content */}
          <div className="flex-1 w-full">
            <p className="text-[#B80E28] text-sm font-semibold tracking-widest uppercase mb-3">
              WELCOME TO PNGGO — MADE FOR PNG
            </p>
            <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-5">
              Start Winning in PNG — Slots, Live Casino & Sports, All in One Place
            </h1>
            <p className="text-white/75 text-base leading-7 mb-8 max-w-lg">
              <a href="/" className="text-[#B80E28] hover:underline">PNGGO</a> is built for Papua New Guinea players — a familiar, welcoming experience with three fast ways to play:{' '}
              <strong className="text-white/90">online slots</strong>,{' '}
              <strong className="text-white/90">live casino</strong>, and{' '}
              <strong className="text-white/90">sports betting</strong>. Deposit in PGK, grab today’s promos, and tap{' '}
              <strong className="text-white/90">JOIN NOW</strong> to start in seconds.
            </p>
            <a
              href="https://pnggo.bet/RFLANDINGPAGEPNG"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#B80E28] text-white font-semibold px-8 py-4 rounded-full hover:bg-[#9a0b21] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              JOIN NOW <i className="fas fa-chevron-right text-sm"></i>
            </a>
          </div>

          {/* Right Image */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <img
              src="https://public.readdy.ai/ai/img_res/cdebe11e-4b94-4494-ab15-6ca4c867d5ed.png"
              alt="PNGGO Online Casino - Best Gaming Experience in Papua New Guinea"
              className="w-full max-w-lg object-contain"
              style={{ animation: 'floatUpDown 3s ease-in-out infinite' }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes floatUpDown {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-18px); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px) translateX(0px); opacity: 0.3; }
          50% { transform: translateY(-20px) translateX(10px); opacity: 0.7; }
        }
      `}</style>
    </section>
  );
}
